module.exports = __webpack_public_path__ + "img/p14.373b2ef6.png";